import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Link
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { api } from '../api';
import SafePassImage from '../assets/logo.png';
import '../styles/styles.css';

const Login = ({ notificationsRef }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.logoutMessage) {
      notificationsRef.current.showSnackbar(location.state.logoutMessage, 'success');
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate, notificationsRef]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await api.login({ username, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user_id', data.user_id);
      localStorage.setItem('username', data.username);
      localStorage.setItem('name', data.name || '');
      localStorage.setItem('avatar_url', data.avatar_url || '');
      localStorage.setItem('darkMode', String(data.dark_mode || false));
      notificationsRef.current.showSnackbar(`Welcome back, ${data.username}!`, 'success');
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      notificationsRef.current.showSnackbar(err.message, 'error');
      setLoading(false);
    }
  };

  return (
    <Box className="safeContainer">
      <Paper className="safePaper" elevation={0}>
        <Box className="safeHeader">
          <Box component="img" src={SafePassImage} alt="SafePass" className="safeLogo" />
          <Typography variant="body2" color="text.secondary" align="center">
            All passwords under your control
          </Typography>
        </Box>

        <form onSubmit={handleSubmit} noValidate style={{ width: '100%' }}>
          <TextField
            required fullWidth margin="normal" label="Username"
            autoComplete="username" autoFocus value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            required fullWidth margin="normal" label="Password"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword((p) => !p)} onMouseDown={(e) => e.preventDefault()} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button type="submit" fullWidth variant="contained" className="safeSubmitButton" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>

          <Box className="safeLinkContainer">
            <Link component={RouterLink} to="/register" variant="body2" className="safeLink">Sign Up</Link>
            <Link component={RouterLink} to="/forgot-password" variant="body2" className="safeLink">Forgot Password?</Link>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default Login;